import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Crumb = class Crumb extends Vue {
    created() {
    }
    clickCrumb(step) {
        this.$emit("click-crumb", step);
    }
};
tslib_1.__decorate([
    Prop({ type: [Number, String], default: 1 })
], Crumb.prototype, "settingPage", void 0);
Crumb = tslib_1.__decorate([
    Component({
        name: 'Crumb',
    })
], Crumb);
export default Crumb;
